import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import SpotToReserve from './SpotToReserve';
import SpotToRemove from './SpotToRemove';
import CheckoutActions from './CheckoutActions';
import SpotsToRemoveOptions from './SpotsToRemoveOptions';
import CheckoutMessage from './../../components/checkout/CheckoutMessage';
import CheckoutPageHeader from './../../components/checkout/CheckoutPageHeader';
import { pendingTimeToCheckout, isCurrentCheckoutEvent } from './../../utils';
import { setTimeStamp } from './../../actions/checkout';

import { CHECKOUT_EVENTS, LOCK_PARKING_GROUP_NAME } from './../../constants';

const isHold = event => (event === CHECKOUT_EVENTS.hold);

class Checkout extends Component {
  constructor(props) {
    super(props);
    this.timerInterval = null;
    this.state = {
      pendingTime: pendingTimeToCheckout(props.timeStamp)
    };
  }

  componentDidMount() {
    this.initInterval(this.props);
  }

  componentWillReceiveProps(nextProps) {
    if(!this.timerInterval && nextProps.event && nextProps.timeStamp){
      this.initInterval(nextProps);
    }
  }

  componentWillUnmount() {
    window.clearInterval(this.timerInterval);
  }

  initInterval({ event, timeStamp }){
    if(isHold(event)){
      this.timerInterval = window.setInterval(() => {
        const pendingTime = pendingTimeToCheckout(timeStamp);
        this.setState({ pendingTime });
        if(!pendingTime.isValid) {
          window.clearInterval(this.timerInterval);
          this.props.setTimeStamp(0);
        }
      }, 1000);
    }
  }

  checkIsInValidTimer(event, pendingTime, isBackendRelasedSpot) {
    return isHold(event) && !pendingTime.isValid && isBackendRelasedSpot;
  }

  areAllAttendeeSpotsLocked() {
    // no lock group name set, all of the attendee's spots are unlocked
    if (!LOCK_PARKING_GROUP_NAME) {
      return false;
    }

    const { attendee } = this.props;

    if (!attendee.assignments || attendee.assignments.length === 0) {
      return false;
    }

    return attendee.assignments.every((assignment) => assignment.group.toLowerCase() === LOCK_PARKING_GROUP_NAME.toLowerCase());
  }

  isSpotLockedForAttendee(spotName) {
    // no lock group name set, no spot is locked
    if (!LOCK_PARKING_GROUP_NAME) {
      return false;
    }

    const { attendee } = this.props;

    if (!attendee.assignments || attendee.assignments.length === 0) {
      return false;
    }

    return attendee.assignments.some((assignment) =>
        assignment.group.toLowerCase() === LOCK_PARKING_GROUP_NAME.toLowerCase() && assignment.vehicleNumber === spotName);
  }

  render(){
    const {spotToReserve, spotToUnreserve, email, event, isBackendRelasedSpot} = this.props;
    const { pendingTime } = this.state;
    const isInValidTimer = this.checkIsInValidTimer(event, pendingTime, isBackendRelasedSpot);
    const areAllAttendeeSpotsLocked = this.areAllAttendeeSpotsLocked();
    const isSpotLockedForAttendee = this.isSpotLockedForAttendee(spotToUnreserve);

    return (
        <div className="map-page-content">
          <form>
            <CheckoutPageHeader {...this.props} pendingTime={pendingTime} isInValidTimer={isInValidTimer} />

            <div className="map-page-body">
              {spotToReserve && <SpotToReserve spotName={spotToReserve} event={event} isInValidTimer={isInValidTimer} />}

              { isCurrentCheckoutEvent("trade") &&  <SpotsToRemoveOptions />}

              {spotToUnreserve && <SpotToRemove spotName={spotToUnreserve} />}

              <CheckoutMessage  {...this.props} isInValidTimer={isInValidTimer} />

            </div>

            <CheckoutActions {...this.props} isInValidTimer={isInValidTimer} hideConfirmButton={areAllAttendeeSpotsLocked} disableConfirmButton={isSpotLockedForAttendee} />

          </form>

        </div>
    );
  }

}

const mapStateToProps = (state) => {
  const { isBackendRelasedSpot, event, requestId, timeStamp,spotToUnreserve, spotToReserve } = state.checkout;
  return {
    spotToReserve,
    spotToUnreserve,
    timeStamp,
    requestId,
    event,
    isBackendRelasedSpot,
    email: state.user.email,
    attendee: state.userAccommodationInfo.attendee,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ setTimeStamp }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Checkout);



// WEBPACK FOOTER //
// ./src/containers/checkout/CheckoutPage.js